<h4 mat-dialog-title>
  <span *ngIf="!data;else editHeader">
    Creazione nuovo gruppo
  </span>
  <ng-template #editHeader>
    Modifica gruppo {{data.nome}}
  </ng-template>
</h4>
<div mat-dialog-content>
  <form *ngIf="form" [formGroup]="form" class="mt-4" (keydown.enter)="edit()">

    <div>
      <mat-form-field>
        <mat-label>Nome</mat-label>
        <input matInput formControlName="nome">
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>Giorni automatismo scadenza</mat-label>
        <input matInput type="number" formControlName="giorni_automatismo_scadenza">
      </mat-form-field>
    </div>
  </form>
  <button mat-raised-button (click)="edit()" color="primary">Salva</button>
</div>